import React from 'react'
import DropDown from './DropDown'

type Props = {
  validThicknesses: string[],
  onThicknessChange: (event: React.ChangeEvent<HTMLSelectElement>) => void,
  selectedThickness: string
}

const ThicknessSelection = ({ validThicknesses, onThicknessChange, selectedThickness }: Props): React.JSX.Element => {
  if (validThicknesses.length > 1) {
    return <DropDown values={validThicknesses} onValueChange={onThicknessChange} value={selectedThickness} />
  } else {
    return <p>{selectedThickness}</p>
  }
}

export default ThicknessSelection
